var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.text),expression:"text",modifiers:{"hover":true}}],staticClass:"infoicon",attrs:{"src":require("../assets/infoicon.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }